mutation TeardownDirectorySyncForInstance {
    teardownDirectorySyncForInstance {
        success
    }
}
